/**
 * Keep the values in lowercase only, because
 * LanguageService.getCurrentLanguage() returns in lowercase.
 */
export enum LocaleTypes {
  BRAZIL = 'pt-br',
  AUSTRALIA = 'en-au',
  BOLIVIA = 'es-bo',
  MEXICO = 'es-mx',
  ARGENTINA = 'es-ar',
  COLOMBIA = 'es-co'
}